// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"d36b71f1","29":"d3ac7b46","324":"56914f20","395":"548e4e3a","538":"b957ccae","598":"8b288f17","976":"91b6af76"}[chunkId] + ".chunk.css";
};